import React, { Fragment } from 'react';
import { graphql } from 'gatsby';
import Header from '@components/Header';
import Footer from '@components/Footer';
import FeaturedPost from '@components/FeaturedPost';
import ReadingArticle from '@theme/components/ReadingArticle';
import SharePage from '@theme/components/SharePage';
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import BackgroundImage from 'gatsby-background-image';
import GatsbyImage from 'gatsby-image';
import { find } from 'lodash';

const ImageCss = css`
  position: relative;
  overflow: hidden;
  border-radius: 170px;
  margin-right: 2rem;
  min-height: 120px;
  min-width: 120px;
`;

export default function Post(all) {
  console.log(all);
  const { data, pageContext: { language, refs, layouts }} = all;

  const { post, author} = data;

  return (
    <Fragment>
      <FeaturedPost
        featured={post}
        author={author}
        language={language}
      >
        <Header
          language={language}
          refs={refs}
          layouts={layouts}
        />
      </FeaturedPost>
      <ReadingArticle body={post.acf.body}>
        <SharePage page={{ hashtag: 'blog', url: 'https://nospoilers.ai', description: 'This is' }} />
        {author &&
          <Fragment>
            <hr />
            <div className="media">
              <GatsbyImage
                css={ImageCss}
                fluid={author.acf.photo.localFile.sharp.fluid}
              />
              <div className="media-body">
                <h5 className="mt-0">{author.acf.name}</h5>
                {author.acf.description && (
                  <div dangerouslySetInnerHTML={{ __html: author.acf.description }} />
                )}
              </div>
            </div>
          </Fragment>
        }
      </ReadingArticle>
      <Footer
        language={language}
        layouts={layouts}
      />
    </Fragment>
  );
}

export const query = graphql`
  query($id: Int, $authorId: Int) {
    post: wordpressWpBlogposts(wordpress_id: { eq: $id }) {
      acf {
        author
        body
        publish_date
        slug
        title
        featured_image {
          localFile {
            sharp: childImageSharp {
              fluid(maxWidth: 1920) {
                ...GatsbyImageSharpFluid
              }
            }
          }
        }
      }
    }
    author: wordpressWpTeammembers(wordpress_id: { eq: $authorId }) {
      acf {
        description
        job_title
        name
        photo {
          localFile {
            sharp: childImageSharp {
              fluid(maxWidth: 170, maxHeight: 170) {
                ...GatsbyImageSharpFluid
              }
            }
          }
        }
      }
    }
  }
`;